import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFee, updateFee, deleteFee } from '../services/smr-admin';
import type { FeePayload } from '../services/smr-admin';
import { feeKeys } from './useFeesQuery';

export const useFeeMutations = () => {
    const queryClient = useQueryClient();
    const invalidate = () => queryClient.invalidateQueries({ queryKey: feeKeys.lists() });

    return {
        createMutation: useMutation({ mutationFn: createFee, onSuccess: invalidate }),
        updateMutation: useMutation({
            mutationFn: ({ id, payload }: { id: string; payload: FeePayload }) => updateFee(id, payload),
            onSuccess: invalidate,
        }),
        deleteMutation: useMutation({ mutationFn: deleteFee, onSuccess: invalidate }),
    };
};
